import { useRef } from "react"
import Box from "@mui/material/Box"
import Avatar from "@mui/material/Avatar"
import GroupsIcon from "@mui/icons-material/Groups"
import { MONO, CHAT_COLOR } from "../constants"
import { compressImage } from "../utils/chatMedia"

export function GroupImagePicker({ image, onPick, label }) {
  const ref = useRef(null)
  const handle = async (e) => {
    const file = e.target.files?.[0]
    if (file) { const b64 = await compressImage(file); if (b64) onPick(b64) }
    e.target.value = ""
  }
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.25 }}>
      <input ref={ref} type="file" accept="image/*" style={{ display: "none" }} onChange={handle} />
      {image
        ? <Avatar src={image} sx={{ width: 44, height: 44 }} />
        : <Avatar sx={{ width: 44, height: 44, bgcolor: "rgba(var(--app-fg-rgb),0.06)" }}><GroupsIcon sx={{ fontSize: 22 }} /></Avatar>}
      <Box onClick={() => ref.current?.click()}
        sx={{ fontFamily: MONO, fontSize: "0.64rem", color: CHAT_COLOR, cursor: "pointer", "&:hover": { textDecoration: "underline" } }}>
        {label ?? "Set group image"}
      </Box>
      {image && (
        <Box onClick={() => onPick("")} sx={{ fontFamily: MONO, fontSize: "0.62rem", color: "rgba(var(--app-fg-rgb),0.3)", cursor: "pointer", "&:hover": { color: "var(--app-error)" } }}>
          remove
        </Box>
      )}
    </Box>
  )
}
